/**
 * Validación de checkout para rangos
 */

if ( typeof RangoCheckout !== 'function' ) {

	class RangoCheckout {
		
		constructor() {
			this.init();
		}

		init() {
			const checkoutButton = document.getElementById('CheckOut');
			const checkoutForm = document.getElementById('checkout-form');
			
			if (checkoutButton && checkoutForm) {
				checkoutForm.addEventListener('submit', async (e) => {
					e.preventDefault();
					
					if (typeof window.RangosSystem === 'undefined') {
						// Si no hay sistema de rangos, continuar normalmente
						checkoutForm.submit();
						return;
					}
					
					// Cargar el carrito actual
					await window.RangosSystem.loadCart();
					
					// Validar el carrito
					const validacion = window.RangosSystem.validarCarrito();
					
					if (!validacion.valido) {
						// Mostrar mensaje de error
						const errorAlert = document.createElement('span');
						errorAlert.className = 'alert alert--error rango-checkout-alert';
						errorAlert.textContent = validacion.mensaje || 'Tu carrito no cumple las condiciones de compra por rangos. Ajusta tus productos para continuar.';
						
						// Eliminar alerta anterior si existe
						const existingAlert = checkoutForm.querySelector('.rango-checkout-alert');
						if (existingAlert) {
							existingAlert.remove();
						}
						
						// Añadir la alerta antes del botón
						checkoutButton.parentElement.insertBefore(errorAlert, checkoutButton);
						
						// Scroll al error
						errorAlert.scrollIntoView({ behavior: 'smooth', block: 'center' });
						
						return false;
					}
					
					// Si es válido, continuar con el checkout
					checkoutForm.submit();
				});
			}
		}
	}

	// Inicializar cuando el DOM esté listo
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			new RangoCheckout();
		});
	} else {
		new RangoCheckout();
	}

}

